<template>
  <section>
    <div
      class="comment-input"
      :style="{'margin-top': isShowComment ? '-46px' : '0'}"
    >
      <!-- @人的列表 -->
      <div
        v-if="showAtList"
        ref="atList"
        class="at-list"
      >
        <ul class="at-ul">
          <li
            v-if="showAtAll"
            class="at-item"
            index="0"
            :class="[(0 === selectedAtListIndex) ? 'select' : '']"
            @click="selectAt(seletAll)"
          >
            <span
              class="user-name"
              title=""
            >{{ $t('所有人') }}</span>
          </li>
          <li
            v-for="(item,atIndex) in atListData"
            :key="atIndex"
            :index="showAtAll ? atIndex + 1 : atIndex"
            :class="[((showAtAll ? atIndex + 1 : atIndex) === selectedAtListIndex)
              ? 'select' : '', 'at-item']"
            @click="selectAt(item)"
          >
            <span
              class="user-name"
              :title="item.user_name"
            >{{ item.user_name }}</span>
            <span
              class="user-email"
              :title="item.email"
            >{{ item.email }}</span>
          </li>
        </ul>
      </div>
      <div class="comment-input-container">
        <!-- 输入内容的评论框 -->
        <transition
          name="comment"
          @after-enter="afterEnter"
          @after-leave="afterLeave"
        >
          <div v-if="isShowComment|| forceShow">
            <div
              ref="editContent"
              class="edit-content isEditing"
              contenteditable="false"
              @click="editBoxFocus()"
              @keyup="editing($event)"
              @keydown="dealWithKey($event)"
              @compositionstart="handleCompositionStart"
              @compositionupdate="handleCompositionUpdate"
              @compositionend="handleCompositionEnd"
            >
              <span
                v-for="(data, index) in editContentData"
                :key="index"
                :class="data.type?'editing-box':'at-other'"
                :contenteditable="data.type"
                @focus="setLastEdit(index)"
                @click.stop=""
                v-text="data.content + (data.type?'':' ')"
              />
            </div>
            <span
              :class="['word-count',wordCount>200?
                'word-count-show-red':(wordCount>=190?'word-count-show-normal':'')]"
            >
              {{ wordCount+'/200' }}
            </span>
          </div>
        </transition>
        <div
          v-if="showCommBtn"
          class="comment-btn"
          @click.stop="showComment(true)"
        >
          {{ $t('请输入评论，限制200字符') }}
        </div>
      </div>
      <div
        :class="['btn','submit',(wordCount===0||wordCount>200)?'btn-disabled':'']"
        @click.stop="addComment()"
      >
        {{ $t('发送') }}
      </div>
      <div
        v-show="!showCommBtn"
        :class="['btn','clear']"
        @click.stop="clearComment()"
      >
        {{ $t('取消') }}
      </div>
      <div
        class="btn cancle"
        @click.stop="cancelComment()"
      >
        {{ $t('@提醒他') }}
      </div>
    </div>
  </section>
</template>
<script>
import _$ from 'js/api/getdata'
import store from 'store'
import * as Util from 'js/util/util'
import { sendLogBuryingPointMethods } from 'js/api/privateApi/private-apis'

export default {
  props: {
    forceShow: {
      default: () => ({}),
    },
    replyShowComment: {
      type: Boolean,
    },
  },
  data() {
    return {
      showAtAll: false,
      wordCount: 0,
      isShowComment: false,
      atListData: [],
      noAtData: [
      ],
      seletAll: {
        type: 'all',
      },
      showAtList: false,
      isEdit: true,
      commentText: '',
      editContentData: [
        {
          type: true,
          content: '',
        },
      ],
      // 上一个编辑数据
      lastEditIndex: 0,
      lastRange: null,
      startAt: false,
      atContent: '',
      atContentTemp: '', // 缓存atContent
      atList: [],
      selectedAtListIndex: 0, // 选中at列表项index
      isChineseEditing: false, // 正在中文输入
      eiditingTimer: undefined, // 输入防抖
      showCommBtn: true,
      canShowContentList: true,
    }
  },
  computed: {
    currentUserEmail() {
      return store.state.lenovoData.LenovoData.userinfo.email
    },
    // 评论框输入@是否可以上下选择
    canSelectUser() {
      return (this.showAtAll && this.atListData.length >= 1) || this.atListData.length > 1
    },
    /**
         * 获取当前查看文件的信息
         */
    selectedData() {
      return store.state.curFileInfo
    },
    currentUserName() {
      return store.state.lenovoData.LenovoData.userinfo.user_name
    },
    // 当前选中数据所在
    currentPath() {
      return localStorage.getItem('currentPath')
    },
  },
  watch: {
    forceShow(value) {
      if (value) {
        this.editContentData = [{ type: true, content: '' }]
        this.editContentData.push(this.createText(this.$t('回复')))
        this.editContentData.push(this.createAtLink(value.currentUser.user_name))
        this.editContentData.push(this.createText(':'))
        this.editContentData.push(this.createText())
        this.$nextTick(() => {
          this.$refs.editContent.click()
        })
      }
    },
    commentText: {
      handler() {
        let word = 0
        const contextBox = document.querySelectorAll('.editing-box')
        let maxLen = 0
        if (contextBox[0] !== undefined) {
          for (const editingbox of Array.from(contextBox)) {
              if (Util.isIE()) {
                if (editingbox.innerText.replace(/\s/g, '').length > maxLen) {
                  maxLen = editingbox.innerText.replace(/\s/g, '').length
                  word += maxLen
                }
              } else {
                word += editingbox.innerText.replace(/\s/g, '').length
              }
          }
          word += this.atList.length
        }
        this.wordCount = word
      },
      deep: true,
    },


    atContent(val) {
      this.selectedAtListIndex = 0
      if (this.currentPath === '/') {
        this.atListData = [{ user_name: this.$t('企业空间根目录下无法@成员'), value: 'errorTips' }]
        return this.atListData
      }
      if (this.canShowContentList) {
        this.getAuthList(val)
      }
      return this.atListData
    },
    showAtList(val) {
      this.startAt = val
    },
    isChineseEditing(val) {
      if (!val) { // 结束中文输入更新atContentTemp
        this.atContentTemp = this.atContent
      }
    },
    isShowComment(val) {
      this.$emit('showComment', val)
    },
    replyShowComment(val) {
      if (val) {
        this.isShowComment = val
      }
    },
  },
  methods: {
    afterEnter() {
      this.showCommBtn = false
    },
    /**
         * 当动画消失时才显示评论初始框
         */
    afterLeave() {
      this.showCommBtn = true
      this.wordCount = 0
    },
    /**
         * 展开或者收起评论输入框
         */
    showComment(value) {
      // 这里有可能事件冒泡，已在dom中加事件修饰符
      this.isShowComment = value
      if (!(this.isShowComment || this.forceShow)) this.refreshData()
      if (value) {
        this.editBoxFocus()
      } else {
        this.showAtList = false
        if (this.forceShow) {
          this.$emit('hideFooter')
        }
      }
      if (value) {
        this.showCommBtn = false
      }
    },
    refreshData() {
      // 重置一些变量数据
      this.editContentData = [
        {
          type: true,
          content: '',
        },
      ]
      this.lastEditIndex = 0
      this.startAt = false
      this.atContent = ''
      this.lastRange = null
      this.commentText = ''
      this.atList = []
    },

    editBoxFocus() {
      this.$nextTick(() => {
        const root = this.$refs.editContent
        // 聚焦
        this.keepLastIndex(root.lastChild)
      })
    },
    /**
        *获取光标的位置
        */
    keepLastIndex(obj) {
      if (window.getSelection) { // ie11 10 9 ff safari
        obj.focus() // 解决ff不获取焦点无法定位问题
        const range = window.getSelection()// 创建range
        range.selectAllChildren(obj)// range 选择obj下所有子内容
        range.collapseToEnd()// 光标移至最后
      } else if (document.selection) { // ie10 9 8 7 6 5
        const range = document.selection.createRange()// 创建选择对象
        range.moveToElementText(obj)// range定位到obj
        range.collapse(false)// 光标移至最后
        range.select()
      }
    },

    setLastEdit(index) {
      this.lastEditIndex = index
    },
    updateFocus(index) {
      // 这个地方要等到dom加载完成才能显示光标，目前的办法就是settimeout
      setTimeout(() => {
        const data = this.editContentData[index] || {}
        const root = this.$refs.editContent
        if (data.type) {
          if ((this.lastEditIndex + 2) === index) {
            if (root.childNodes[index]) {
              root.childNodes[index].focus()
            }
          }
        }
      }, 100)
    },
    createAtLink(data) {
      return {
        type: false,
        content: `@${data}` || '',
      }
    },
    createText(data) {
      return {
        type: true,
        content: data || '',
      }
    },
    /**
         * 人员列表点选择
         */
    selectAt(data) {
      if (data.value === 'errorTips' || this.atListData === this.noAtData || this.atListData[0].user_name === this.$t('无匹配的人')) {
        return
      }
      if (this.currentUserName === data.user_name && this.currentUserEmail === data.email) {
        this.$toast.simpleShow(this.$t('用户不能@自己!'), 'warn')
        return
      }
      if (this.atList.includes(0) && data.type === 'all') {
        this.$toast.simpleShow(this.$t('每条评论只允许@所有人一遍!'), 'warn')
        return
      }
      if (this.atList.includes(data.uid)) {
        this.$toast.simpleShow(this.$t('用户不能@同一个人!'), 'warn')
        return
      }
      if (this.atList.length >= 10) {
        this.$toast.simpleShow(this.$t('用户最多能@10个人!'), 'warn')
        return
      }
      this.showAtList = false
      this.canShowContentList = false
      const root = this.$refs.editContent
      let atLink = ''
      if (data.type === 'all') {
        atLink = {
          type: false,
          content: this.$t('@所有人'),
        }
        this.atList.push(0)
      } else {
        atLink = this.createAtLink(data.user_name)
        this.atList.push(data.uid)
      }
      // let before =
      let after
      const index = this.lastEditIndex
      let afterStr
      // 处理@链接前边的@text
      if (this.editContentData[index]) {
        // 这里的思路是先删除对象，然后添加对象
        // 测试结果是对象要是绑定数据就需要子一级对象的添加或者删除
        this.editContentData.splice(index, 1)
        const str = root.childNodes[index].innerText
        const idx = str.indexOf('@')
        // 这个地方将数据分成两段，用来将原来的span截断成为两个
        afterStr = str.substring(idx + this.atContent.length + 1)
        if (afterStr === this.atContent) {
          after = this.createText('')
        } else {
          after = this.createText(afterStr || '')
        }
        this.$nextTick(() => {
          this.editContentData.splice(index, 0, this.createText(str.substring(0, idx)))
        })
      }

      // 在text之后插入链接
      this.editContentData.splice((index + 1), 0, atLink)
      // 检测链接之后的数据是否存在
      if (this.editContentData[index + 2]) {
        const nextData = this.editContentData[index + 2]
        // 存在就检测是否为text,不是的话就插入after
        if (!nextData.type) {
          this.editContentData.splice((index + 2), 0, after)
        }
      } else {
        // 不存在就插入after
        this.editContentData.splice((index + 2), 0, after)
      }

      this.$nextTick(() => {
        this.updateFocus(index + 2)
        this.atContent = ''
        this.startAt = null
        this.commentText = this.$refs.editContent.innerText
        const reg = /^回复@\S+\s+:/g
        this.commentText = this.commentText.replace(reg, '')
      })
    },
    cursorMoveEnd(index) {
      const root = this.$refs.editContent
      const ctrl = root.childNodes[index]
      const userSelection = window.getSelection()
      const range = document.createRange()
      ctrl.focus()
      range.selectNodeContents(ctrl)
      range.collapse(false)
      userSelection.removeAllRanges()
      userSelection.addRange(range)
    },
    // 删除当前节点之前的link
    deleteAtLink(event) {
      const e = event
      const datas = this.editContentData
      const index = this.lastEditIndex
      // 前一个存在
      if (datas[index - 1]) {
        if (datas[index - 1].type) {
          datas.splice(index, 1)
        } else {
          // 前一个是链接
          datas.splice((index - 1), 1)
          this.atList.pop()
        }
        // 光标归位才能继续输入
        e.returnValue = false
        this.$nextTick(() => {
          this.cursorMoveEnd(index - 1)
          e.returnValue = true
        })
      }
    },
    // 处理内容,input监听事件
    editing(e) {
      // 实时获取字符数
      this.commentText = this.$refs.editContent.innerText
      const reg = /^回复@\S+\s+:/g
      this.commentText = this.commentText.replace(reg, '')
      const contextBox = document.querySelectorAll('.editing-box')
      const lastContextBox = contextBox[contextBox.length - 1]
      const lastContent = lastContextBox.innerHTML || ''
      if (lastContent[lastContent.length - 1] !== '@' && lastContent.indexOf('@') < 0) {
        this.showAtList = false
      }
      const { key } = e
      const { keyCode } = e
      if (key === 'Backspace' || keyCode === 8) { // 删除就退出
        return
      }
      if (key === 'Enter' || e.code === 'Enter' || keyCode === 13) { // enter就退出
        return
      }
      if ((key === 'Space' || e.code === 'Space' || keyCode === 32) && this.startAt) { // Space就退出并且是在@状态下
        return
      }
      if ((key === 'ArrowDown' || keyCode === 40) && this.startAt) { // ArrowDown就退出并且是在@状态下
        return
      }
      if ((key === 'ArrowUp' || keyCode === 38) && this.startAt) { // ArrowUp就退出并且是在@状态下
        return
      }
      const index = Array.prototype.indexOf.call(this.$refs.editContent.childNodes, e.target)
      this.lastEditIndex = index
      const eInput = e.target
      let cursurPosition = -1
      if (window.getSelection()) { // 非IE浏览器
        cursurPosition = window.getSelection().focusOffset
      } else { // IE
        const range = document.selection.createRange()
        range.moveStart('character', -eInput.value.length)
        cursurPosition = range.text.length
      }
      const word = eInput.innerText.substr(cursurPosition - 1, 1)
      // 特殊字符处理
      if (word === '@') {
        this.canShowContentList = true
        if (!this.startAt && !this.showAtList) { // @后如果显示at列表并且at列表不为空则不进入
          this.selectedAtListIndex = 0
          this.startAt = true
          this.atContent = ''
          this.atContentTemp = ''
          this.atListData = this.noAtData
          this.showAtList = true
          if (this.currentPath === '/' && store.state.curFileInfo.path_type === 'ent') {
            this.atListData = [{ user_name: this.$t('企业空间根目录下无法@成员'), value: 'errorTips' }]
            return
          }
          this.getAuthList(' ')
        }
      } else if (this.startAt && word !== null && !this.isChineseEditing) { // 正在中文输入就不进入等待中文输入完成
        const aIndex = eInput.innerText.lastIndexOf('@')
        const wordTemp = eInput.innerText.substring(aIndex + 1, cursurPosition)
        this.atContent = wordTemp
      }
    },
    // 配合input处理特殊key，监听keydown
    dealWithKey(event) {
      const e = event
      const { key } = e
      const { keyCode } = e
      let selction = ''
      let range = ''
      if (window.getSelection()) { // 非IE浏览器
        selction = window.getSelection()
        range = selction.getRangeAt(0)
      } else { // IE
        range = document.selection.createRange()
        range.moveStart('character', -this.atContent.length)
      }
      // @+空格
      if (keyCode === 32) {
        this.canShowContentList = true
        this.selectedAtListIndex = 0
        this.commentText = this.$refs.editContent.innerText
        const reg = /^回复@\S+\s+:/g
        this.commentText = this.commentText.replace(reg, '')
        if (this.commentText.charAt(this.commentText.replace(/(\s*$)/g, '').length - 1) === '@') {
          setTimeout(() => {
            this.atContent = `${this.atContent} `
          }, 200)
        }
      }
      // 方向键
      if (keyCode === 38 && this.canSelectUser) { // 键盘方向键 up
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.event.returnValue = false
        }
        if (this.selectedAtListIndex > 0) {
          this.selectedAtListIndex -= 1
        }
        this.checkScroll('up')
        return
      } if (keyCode === 40 && this.canSelectUser) { // 键盘方向键 down
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.event.returnValue = false
        }
        if ((this.showAtAll && this.selectedAtListIndex < this.atListData.length)
          || this.selectedAtListIndex < this.atListData.length - 1) {
          this.selectedAtListIndex += 1
        }
        this.checkScroll('down')
        return
      }
      // 禁止enter默认返回值
      if ((key === 'Enter' || keyCode === 13) && !this.isChineseEditing) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.event.returnValue = false
        }
        if (this.showAtList && this.atListData.length > 0) {
          if (this.atListData.length === 1 && this.atListData[0].email !== '' && this.atListData[0].email !== undefined) {
            if (this.showAtAll) {
              if (this.selectedAtListIndex <= 0) {
                this.selectAt(this.seletAll)
              } else {
                this.selectAt(this.atListData[this.selectedAtListIndex - 1])
              }
            } else {
              this.selectAt(this.atListData[this.selectedAtListIndex])
            }
          } else if (this.atListData.length > 1) {
            if (this.showAtAll) {
              if (this.selectedAtListIndex <= 0) {
                this.selectAt(this.seletAll)
              } else {
                this.selectAt(this.atListData[this.selectedAtListIndex - 1])
              }
            } else {
              this.selectAt(this.atListData[this.selectedAtListIndex])
            }
          }
        }
        this.canShowContentList = false
        return
      }
      // 处理删除链接
      if (key === 'Backspace' || keyCode === 8) {
        if (range.startOffset === 0) {
          if (this.lastRange && this.lastRange.startOffset === 0) {
            this.deleteAtLink(e)
          }
        } else if (this.atContent !== '') {
          this.atContent = this.atContent.substring(0, this.atContent.length - 1)
          this.atContentTemp = this.atContent// 删除时与atContent同步
        }
        // 实时获取字符数-这里需要注意的，删除操作还未执行完成，需要提前字符串-2
        this.commentText = this.$refs.editContent.innerText
        const reg = /^回复@\S+\s+:/g
        this.commentText = this.commentText.replace(reg, '')
        // 删除只剩@要弹出@列表
        if (this.commentText.charAt(this.commentText.length - 2) === '@') {
          this.showAtList = true
        }
        // 都删除没了不显示
        if (this.commentText.charAt(this.commentText.length - 2) === '') {
          this.showAtList = false
        }
      }
      this.lastRange = range
    },
    // 箭头控制上下选中后滚动列表
    checkScroll(type) {
      const currentItem = this.$refs.atList.querySelector('.select')
      const index = this.selectedAtListIndex
      this.$nextTick(() => {
        if (type === 'down') {
          this.$refs.atList.scrollTop = Math.max((index - 4) * currentItem.offsetHeight,
            this.$refs.atList.scrollTop)
        } else if (type === 'up') {
          this.$refs.atList.scrollTop = Math.min(index * currentItem.offsetHeight,
            this.$refs.atList.scrollTop)
        }
      })
    },
    // 输入中文时按字母先查后再用完成的中文查
    chineseEditing(e) {
      const eInput = e.target || e.srcElement
      let cursurPosition = -1
      if (window.getSelection()) { // 非IE浏览器
        cursurPosition = window.getSelection().focusOffset
      } else { // IE
        const range = document.selection.createRange()
        range.moveStart('character', -eInput.value.length)
        cursurPosition = range.text.length
      }
      const word = eInput.innerText.substr(cursurPosition - 1, 1)
      if (this.startAt && word !== null) {
        const aIndex = eInput.innerText.lastIndexOf('@')
        const wordTemp = eInput.innerText.substring(aIndex + 1, cursurPosition)
        this.atContent = wordTemp
      }
    },
    // 中文输入开始
    handleCompositionStart() {
      this.isChineseEditing = true
    },
    // 中文输入更新
    handleCompositionUpdate() {
      // this.chineseEditing(e.data);
    },
    // 中文输入结束
    handleCompositionEnd(e) {
      this.chineseEditing(e)
      this.isChineseEditing = false
    },
    /**
         * 发送评论
         */
    addComment() {
      // 评论为空或者字数大于200不执行后面操作
      if (this.wordCount === 0 || this.wordCount > 200) {
        return
      }
      this.$nextTick(() => {
        if (this.$refs.editContent) {
          // 这里之后增加添加评论，刷新评论数据的逻辑
          this.commentText = this.$refs.editContent.innerText
          const data = {
            forceShow: this.forceShow,
            commentText: this.commentText,
          }
          if (data.forceShow) {
            if (data.forceShow.reply_name === '' && data.forceShow.reply_id === 0) { // 回复一级评论 reply_id是目标评论一级id reply_name是回复目标的用户名（回复1，2级都是1级评论的用户名）
              data.forceShow.reply_id = data.forceShow.id
            }
            data.forceShow.reply_name = data.forceShow.currentUser.user_name
            this.atList.push(data.forceShow.currentUser.currentUid)
          }
          if (data.forceShow && data.commentText) {
            const reg = new RegExp(`^\\s*${this.$t('回复')}(@\\S+\\s+):`, 'g')
            data.commentText = data.commentText.replace(reg, '$1')
          }
          this.submitComment()
          this.$refs.editContent.innerText = ''
          this.refreshData()
        }
        this.showComment(false)
      })
    },
    sendLog() {
      const { path, nsid, neid } = this.selectedData
      const pathArray = path.split('/')
      const name = pathArray.pop()
      const pathresult = pathArray.join('/')
      sendLogBuryingPointMethods({
        type: 'normalLog',
        category: 0,
        action: 16,
        pathType: this.selectedData.path_type,
        nsid,
        neid,
        entityStr1: name,
        entityStr2: pathresult,
      })
    },
    submitComment() {
      const reg = new RegExp(`^\\s*${this.$t('回复')}(@\\S+\\s+):`, 'g')
      const self = this
      this.commentText = this.commentText.replace(reg, '$1')
      this.commentText = Util.escapeHTMLString(this.commentText)
      const words = this.commentText.replace(/\s/g, '[nbsp]') // 后端对于web端的encodeURI空格解码有问题，所以约定将空格转为[nsbp]
      const {
        neid, mime_type: mineType, nsid, from, prefix_neid: prefixNeid,
      } = this.selectedData
      const data = {
        neid,
        words,
        comm_type: this.forceShow.reply_id || '',
        commTos: this.atList.length > 0 ? this.atList.join(',') : this.selectedData.creator_uid,
        comm_icon: mineType,
        id: '',
        nsid,
        from,
        prefix_neid: prefixNeid,
      }
      this.sendLog()
      _$.postData('createComment', data).then((res) => {
        if (res.status === 200) {
          self.$emit('refreshData', data)
        }
      }).catch((error) => {
        const { response } = error
        const err = (response && response.data) || error.message
        if (response
          && response.data
          && response.data.state === 400
          && response.data.code === 'comment the createComment method current nameEntry does not exist') {
          this.$store.commit('SET_REQUEST_STATUS', `${404}_${new Date().getTime()}`)
        } else {
          this.$toast.simpleShow(err.message, 'error')
        }
      })
    },
    /**
         *提醒他操作
         */
    cancelComment() {
      if (!this.isShowComment) {
        this.showComment(true)
      }
      this.showAtList = !this.showAtList
      // 点击 @提醒他 时，需要将状态初始化
      if (this.isShowComment === false) {
        this.editContentData = [{
          type: true,
          content: '',
        }]
      }
      this.getAuthList(' ')
      const vm = this
      let timer
      clearTimeout(timer)
      timer = setTimeout(() => {
        const contextBox = document.querySelectorAll('.editing-box')
        const lastContextBox = contextBox[contextBox.length - 1]
        const lastContent = lastContextBox.innerHTML || ''
        // 给最后一个内容加 @
        if (lastContent[lastContent.length - 1] !== '@') {
          lastContextBox.innerHTML = `${lastContent}@`
          vm.editBoxFocus()
        } else if (lastContent[lastContent.length - 1] === '@' && !vm.showAtList) {
          lastContextBox.innerHTML = lastContent.substring(0, lastContent.length - 1)
        }

        this.commentText = this.$refs.editContent.innerText
        const reg = /^回复@\S+\s+:/g
        this.commentText = this.commentText.replace(reg, '')
      }, 200)
    },
    /**
         *清空评论
         */
    clearComment() {
      this.editContentData = []
      // this.$refs.editContent.innerText = ''
      this.showComment(false)
    },
    getAuthList(query) {
      this.showAtAll = false
      if (this.currentPath === '/' && this.$route.params.from === 'ent') {
        this.showAtAll = false
        this.atListData = [{ user_name: this.$t('企业空间根目录下无法@成员'), value: 'errorTips' }]
      } else {
        const data = {
          neid: this.selectedData.neid,
          query,
          offset: 0,
          limit: 5000,
          nsid: this.selectedData.nsid,
        }
        _$.getData('getCommentAuthList', data).then((res) => {
          const da = res.data.contents
          this.showAtList = true
          if (da.length === 0) {
            this.atListData = [{ user_name: this.$t('无匹配的人') }]
            if (query === '') {
              this.showAtAll = false
            }
            return
          }
          this.showAtAll = true
          this.atListData = da
        }).catch((error) => {
          const err = error.response.data
          this.$store.commit('GET_TOAST_INFO', { info: err.message, tipsType: 'error' })
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
// @import '~less/reset.less';
.comment-input-container {
  overflow: hidden;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
}
// .comment-enter-active{
//     transition: height .4s;
// }
// .comment-leave-active {
//     transition: height 0.4s;
// }
// // 进入和离开时
// .comment-enter, .comment-leave-active {
//     height: 32px;
// }
.comment-enter-active {
  animation: bounce-in .2s;
}
.comment-leave-active {
  animation: bounce-in .2s reverse;
}
@keyframes bounce-in {
  from {
    height: 32px;
  }
  to {
    height: 70px;
  }
}
// @keyframes bounce-in {
//   0% {
//       height: 0px;;
//   }
//   25% {
//       height: 20px;;
//   }
//   50% {
//       height: 50px;;
//   }
//   100% {
//       height: 70px;
//   }
// }
.select {
  background: #d8dce1;
}
.new-client-version {
  .comment-input {
    bottom: 14px;
  }
}
section::after {
  content: "";
  clear: both;
  display: table;
}
.comment-btn {
  padding: 7px 10px;
  outline: none;
  font-size: 12px;
  color: #929ca9;
  background: #fff;
  // overflow-x: hidden;
  overflow-y: auto;
  cursor: pointer;
}
.comment-input {
  position: absolute;
  bottom: 4px;
  width: 260px;
  .btn {
    float: left;
    margin-top: 12px;
    // width: 88px;
    // height: 32px;
    // line-height: 32px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
  }
  .submit {
    float: right;
    color: #0A64FA;
    font-size: 12px;
    text-align: right;
  }
  .clear {
    float: right;
    margin-right: 20px;
    font-size: 12px;
    color: #929ca9;
    text-align: right;
  }
  .cancle {
    float: left;
    color: #929CA9;
    font-size: 12px;
    text-align: left;
  }
  .at-list {
    background: #F0F2F6;
    /*border: 1px solid #c5cbd2;*/
    /*-webkit-box-shadow: 0 4px 14px 0 rgba(5,15,40,.1);*/
    /*box-shadow: 0 4px 14px 0 rgba(5,15,40,.1);*/
    border-radius: 2px;
    left: 0;
    width: 260px;
    margin-bottom: 4px;
    max-height: 160px;
    overflow-y: scroll;
    .at-ul {
      max-height: 160px;
      .at-item {
        padding: 0 12px;
        height: 30px;
        line-height: 30px;
        display: flex;
        cursor: pointer;
        font-size: 12px;
        color: #929CA9;
        .user-name, .user-email{
          font-size: 12px;
          color: #1B2733;
          margin-right: 6px;
          overflow: hidden;
          max-width: 115px;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .at-item:hover {
        background: #D8DCE1;
      }
    }
  }
  .at-list::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .at-list::-webkit-scrollbar-thumb {
    margin-left: 20px;
    background: #C1C7CD;
    border-radius: 3px;
  }
  .edit-content {
    background: #fff;
    box-sizing: border-box;
    cursor: text;
    display: block;
    overflow-y: auto;
    padding: 6px;
    white-space: normal;
    width: 262px;
    max-height: 70px;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb  {
      opacity: 0.6;
      background: #C1C7CD;
      border-radius: 100px;
    }
    .editing-box {
      display: inline-block;
      min-width: 2px;
      max-width: 100%;
      height: 12px;
      font-size: 12px;
      // line-height: 1;
      outline: none;
      padding: 0 0.5px;
      word-break: break-all;
      /*max-width: 248px;*/
      -webkit-user-select: auto;
      -webkit-user-modify: read-write-plaintext-only;
    }
    .at-other {
      color: #2C7DF1;
      // cursor: pointer; bug2548
      min-width: 2px;
      max-width: 100%;
      height: 12px;
      font-size: 12px;
      // line-height: 1;
      outline: none;
      padding: 0 0.5px;
      word-break: break-all;
      -webkit-user-select: auto
    }
  }
  .isEditing{
    height: 70px;
  }
  .btn-disabled {
    cursor: default;
    color: #929ca9;
  }
  .word-count{
    cursor: pointer;
    float: left;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    margin-top: 5px;
    text-align: center;
    color: #999;
    position: absolute;
    left: 120px;
    display: none;
  }
  .word-count-show-red{
    display: block;
    color: red;
  }
  .word-count-show-normal{
    display: block;
    color: #999;
  }
}
</style>
